import React, { useState } from 'react';
import { Box, Button, Modal, Typography, Table, TableBody, TableCell, TableHead, TableRow, Paper, TableContainer } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Pour rediriger vers la page d'édition
import { getUserProvider } from '../../../../actions/auth.js'; // Pour obtenir le provider de l'utilisateur

const CompetitionCheckModal = ({ open, onClose, results, onSelectOtherCompetition, onConfirmNone, actualProvider = getUserProvider()  }) => {
  const navigate = useNavigate();

  const handleSelectMyCompetition = (competitionId) => {
    navigate(`/sports/competitions/create/${competitionId}`);
  };

  const handleSelectOtherCompetition = (competition) => {
    onSelectOtherCompetition(competition);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Paper
        sx={{
          padding: 4,
          width: '90%', // 90% de la largeur de l'écran
          maxWidth: '600px', // Limite de la largeur maximale
          margin: 'auto',
          marginTop: { xs: '10%', md: '5%' }, // Gérer la marge en fonction de la taille de l'écran
          maxHeight: '90vh', // Limite de la hauteur
          overflowY: 'auto', // Activer le défilement si le contenu dépasse la hauteur
          boxSizing: 'border-box',
        }}
      >
        <Typography variant="h6" gutterBottom>Vérification des compétitions existantes</Typography>

        {/* Vos compet */}
        <Typography variant="subtitle1" gutterBottom>Vos compétitions</Typography>

        {!results
            .filter((team) => team.provider === actualProvider).length ?
            <Typography variant="subtitle1">Aucune de vos équipes ne correspond à la recherche</Typography>
            :
            (
        <TableContainer sx={{ maxWidth: '100%', overflowX: 'auto' }}>
          <Table size="small" sx={{ minWidth: '100%' }}>
            <TableHead>
              <TableRow>
                <TableCell>Nom</TableCell>
                <TableCell>Discipline</TableCell>
                <TableCell>Saison</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {results
                .filter((competition) => competition.provider === actualProvider)
                .map((competition) => (
                  <TableRow key={competition._id}>
                    <TableCell>{competition.name}</TableCell>
                    <TableCell>{competition.discipline}</TableCell>
                    <TableCell>{competition.season}</TableCell>
                    <TableCell>
                      <Button size="small" variant="contained" onClick={() => handleSelectMyCompetition(competition._id)}>
                        Modifier
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>)}

        {/* Les autres joueurs */}
        <Typography variant="subtitle1" gutterBottom sx={{ marginTop: 2 }}>Les autres compétitions existantes</Typography>

        <TableContainer sx={{ maxWidth: '100%', overflowX: 'auto' }}>
          <Table size="small" sx={{ minWidth: '100%' }}>
            <TableHead>
              <TableRow>
                <TableCell>Nom</TableCell>
                <TableCell>Discipline</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {results
                .filter((competition) => competition.provider !== actualProvider)
                .map((competition) => (
                  <TableRow key={competition._id}>
                    <TableCell>{competition.name}</TableCell>
                    <TableCell>{competition.discipline}</TableCell>
                    <TableCell>
                      <Button size="small" variant="contained" onClick={() => handleSelectOtherCompetition(competition)}>
                        Utiliser
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Aucun des joueurs ne correspond */}
        <Box sx={{ textAlign: 'center', marginTop: 3 }}>
          <Button variant="outlined" onClick={onConfirmNone}>
            Aucune des compétitions ne correspond à ma compétition
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
};

export default CompetitionCheckModal;
